module.exports = __webpack_public_path__ + "img/clock-2.f4445d77.svg";